define('constants/transitionDurations',[], function() {
    // maps to common css transition duration values i.e. "$transition-fast"
    return Object.freeze({
        fast: 150,
        medium: 250,
        slow: 500
    });
});
